module.exports = __webpack_public_path__ + "static/media/calendar.790061bf.svg";